export const KeyPointsType = {
  Strategy: "strategy",
  Market: "market",
  Pipeline: "pipeline",
} as const;

export const ChipVariants = {
  Solid: "solid",
  Outline: "outline",
  Text: "text",
} as const;

export const FundsTagType = {
  MinimumInvestment: "minimumInvestment",
  InvestmentType: "investmentType",
  TargetAudience: "targetAudience",
  RiskReturnProfile: "riskReturnProfile",
  PropertyType: "propertyType",
} as const;
